import { Bounds } from "@nens/deck-gl";

export const getMinMax = async (url: string, bounds: Bounds) => {
  const bboxString = bounds[0] + "," + bounds[3] + "," + bounds[2] + "," + bounds[1];
  const bboxUrl = url.replace("{bbox}", bboxString);
  const epsgUrl = bboxUrl.replace("{epsg}", "4326");

  try {
    const response = await fetch(epsgUrl);
    const parsedResponse = await response.json();

    if (parsedResponse && parsedResponse.minimum && parsedResponse.maximum) {
      return {
        min: parsedResponse.minimum as number,
        max: parsedResponse.maximum as number,
      };
    } else {
      return null;
    }
  } catch (e) {
    console.error(e);
    return null;
  }
};
